import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CouponCodeIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 2 16 16" title={t`Promo Code`} {...props}>
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.894 4.42.575 4.379a1.5 1.5 0 0 1-.338 1.16l-5.744 6.845a1.5 1.5 0 0 1-2.113.185l-4.988-4.185A1.5 1.5 0 0 1 1.1 10.69l5.744-6.846A1.5 1.5 0 0 1 7.93 3.31l4.412-.194a1.5 1.5 0 0 1 1.553 1.303Z"
    />
    <Path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M9.963 5.697a1.189 1.189 0 1 1 1.822 1.528 1.189 1.189 0 0 1-1.822-1.528Z"
    />
  </Icon>
);
